<template>
  <net-popup-menu
    class="flow-draft-popup-menu"
    :height="80"
    :width="250"
    :offset-x="-125"
    :offset-y="-95"
    :closable="false"
  >
    <!-- <template #title>
      {{ $t("actions.createFlow") }}
    </template> -->
    <!-- <input-texteditor
      v-if="ctx.endItem != null"
      class="mb-2"
      :label="$t('labels.description')"
      :value="description"
      @update:value="description = $event"
    /> -->
    <template v-if="ctx.endElement != null">
      <button class="button mt-2" type="button" @click="createFlow()">
        {{ $t("actions.createFlow") }}
      </button>
    </template>
    <template v-else>
      <p class="message mt-0 mb-2">
        {{ $t("messages.chooseElement") }}
      </p>
    </template>
  </net-popup-menu>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useFlowBuilder } from "./flowBuilder.js";

import NetPopupMenu from "@editor/net/NetPopupMenu.vue";
// import InputTexteditor from "@core/input/TextEditor.vue";

import { useFlowBranchStore } from "@editor/items/flow/flowBranches.store";
import { useSelectionStore } from "@editor/store/editor/selection.store";

import type { FlowItem } from "./FlowItem";

const emit = defineEmits<{
  (e: "created", flow: FlowItem): void;
}>();

const ctx = useFlowBuilder();

const flowBranchStore = useFlowBranchStore();
const selectionStore = useSelectionStore();

const relationDraftId = computed(() => {
  const { baseElement, endElement } = ctx;
  if (endElement == null || baseElement == null) {
    return null;
  }
  return `${baseElement.type}.${baseElement.id}-${endElement.type}.${endElement.id}`;
});

const relationDrafts = computed(() => {
  return {} as Record<string, { description: string }>;
  // return relationStore.relationDrafts;
});

const relationDraft = computed(() => {
  if (relationDraftId.value == null) return null;
  return relationDrafts.value?.[relationDraftId.value];
});

const description = computed({
  get() {
    return relationDraft.value?.description ?? "";
  },
  set(value: string) {
    if (!relationDraft.value) {
      if (relationDraftId.value == null) {
        console.warn("no flow draft id.");
        return;
      }
      relationDrafts.value[relationDraftId.value] = {
        description: value
      };
    } else {
      relationDraft.value.description = value;
    }
  }
});

async function createFlow() {
  if (ctx.baseElement == null) {
    console.warn("can't create flow without base element.");
    return;
  }
  if (ctx.endElement == null) {
    console.warn("can't create flow without end element.");
    return;
  }

  const { flow } = await flowBranchStore.createFlowBetween(ctx.baseElement, ctx.endElement, {
    description: description.value
  });

  ctx.exitFlowBuilder();
  selectionStore.clearAll();
  selectionStore.select(flow);

  emit("created", flow);
  return flow;
}
</script>

<style>
.flow-draft-popup-menu {
  transform-origin: center bottom;
}
</style>
